import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-saas-launch',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './saas-launch.component.html',
  styleUrl: './saas-launch.component.scss'
})
export class SaasLaunchComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  nav(url: any) {
    console.log(url);
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const saasCaseStudySchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/saas-launch",
          "url": "https://www.kalpitatechnologies.com/kalpita-case-studies/saas-launch",
          "name": "End-to-End SaaS Platform for Launching Custom E-commerce Stores – Case Study",
          "description": "Case study on how Kalpita Technologies designed and developed Pariwwway, a commission-free SaaS E-commerce platform that reduces commission costs by up to 20%.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2025-01-28"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/saas-launch#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/case-study", "name": "Case Studies" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/saas-launch", "name": "SaaS E-commerce Launch" } }
          ]
        },
        {
          "@type": "Article",
          "headline": "End-to-End SaaS Platform for Launching Custom E-commerce Stores",
          "articleBody": "Kalpita Technologies designed and developed Pariwwway, a full-fledged multi-tenant SaaS E-commerce platform that empowers business owners to launch, manage, and scale their own branded online stores...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-01-28",
          "image": "https://www.kalpitatechnologies.com/assets/resources/casestudies/mob-saas.webp"
        },
        {
          "@type": "HowTo",
          "name": "How to Build a Commission-Free E-commerce SaaS Platform",
          "step": [
            { "@type": "HowToStep", "name": "Identify Pain Points", "text": "Analyze challenges like high commissions and limited branding control." },
            { "@type": "HowToStep", "name": "Design SaaS Architecture", "text": "Architect a multi-tenant platform with full customization capabilities." },
            { "@type": "HowToStep", "name": "Build Core Features", "text": "Develop storefronts, inventory management, and secure payment processing." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/saas-launch#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How does Pariwwway help businesses reduce costs?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Pariwwway eliminates marketplace commission fees of up to 20% per sale, allowing businesses to retain 100% of their revenue."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(saasCaseStudySchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
}
